<template>
  <div style="z-index:1000">
    <div
      ref="rightArrow"
      class="absolute top-50"
      style="right: 25%; transform: translateY(-50%);"
      @click="next"
    >
      <svg
        ref="rightArrow"
        width="100"
        height="100"
        viewBox="-19 -19 100 100"
        transform-origin="center center"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <circle
            class="circle1"
            style="tranform-origin: center"
            transform-origin="center center"
            cx="30.9224"
            cy="31.1907"
            r="29.6186"
            :stroke="nextArrowColor"
            stroke-width="2"
          />
        </g>
        <path
          class="circle2"
          style="tranform-origin: center"
          d="M30.9231 11.528C20.2648 11.528 11.6245 20.3313 11.6245 31.1907C11.6245 42.0501 20.2648 50.8534 30.9231 50.8534C41.5814 50.8534 50.2217 42.0501 50.2217 31.1907C50.2217 20.3313 41.5814 11.528 30.9231 11.528Z"
          :stroke="nextArrowColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.9222 39.0558L38.6416 31.1908L30.9222 23.3257"
          :stroke="nextArrowColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.2027 31.1907L38.6416 31.1907"
          :stroke="nextArrowColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      ref="leftArrow"
      class="absolute top-50"
      style="left: 25%; transform: translateY(-50%);"
      @click="previous"
    >
      <svg
        ref="leftArrow"
        style="transform: rotate(180deg)"
        width="100"
        height="100"
        viewBox="-19 -19 100 100"
        transform-origin="center center"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <circle
            class="circle1"
            style="tranform-origin: center"
            transform-origin="center center"
            cx="30.9224"
            cy="31.1907"
            r="29.6186"
            :stroke="prevArrowColor"
            stroke-width="2"
          />
        </g>
        <path
          class="circle2"
          style="tranform-origin: center"
          d="M30.9231 11.528C20.2648 11.528 11.6245 20.3313 11.6245 31.1907C11.6245 42.0501 20.2648 50.8534 30.9231 50.8534C41.5814 50.8534 50.2217 42.0501 50.2217 31.1907C50.2217 20.3313 41.5814 11.528 30.9231 11.528Z"
          :stroke="prevArrowColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.9222 39.0558L38.6416 31.1908L30.9222 23.3257"
          :stroke="prevArrowColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.2027 31.1907L38.6416 31.1907"
          :stroke="prevArrowColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>
<script>
import { gsap, Power1 } from 'gsap'
export default {
  name: 'SliderArrows',
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  },
  computed: {
    getSpecLength () {
      return this.$store.state.sideNavLengths.specification
    },
    getPurchaseLength () {
      return this.$store.state.sideNavLengths.purchase
    },
    getFloorLength () {
      return this.$store.state.sideNavLengths.floorPlan
    },
    navLength () {
      switch (this.$route.name) {
        case 'property-specifications':
          return this.getSpecLength
        case 'property-purchase-options':
          return this.getPurchaseLength
        case 'property-floorplans':
          return this.getFloorLength
        default:
          return null
      }
    },
    prevArrowColor () {
      if (this.$store.state.activeTab > 0) {
        switch (this.brand) {
          case 'lh':
            return '#662483'
          case 'lq':
            return '#333333'
          default:
            return '#333333'
        }
      } else {
        return '#C6C6C6'
      }
    },
    nextArrowColor () {
      if (this.$store.state.activeTab >= this.navLength - 1) {
        return '#C6C6C6'
      } else {
        switch (this.brand) {
          case 'lh':
            return '#662483'
          case 'lq':
            return '#333333'
          default:
            return '#333333'
        }
      }
    }
  },
  methods: {
    animArrows () {
      const leftArrow = this.$refs.leftArrow
      const rightArrow = this.$refs.rightArrow
      gsap.fromTo(leftArrow, {
        opacity: 0,
        x: -100
      }, {
        opacity: 1,
        x: 0,
        ease: 'back',
        delay: 1
      })
      gsap.fromTo(rightArrow, {
        opacity: 0,
        x: 100
      }, {
        opacity: 1,
        x: 0,
        ease: 'back',
        delay: 1
      })
    },
    next () {
      this.arrowBounce(this.$refs.rightArrow)
      if (this.$store.state.activeTab >= this.navLength - 1) {
      } else {
        this.$store.commit('setActiveTab', this.$store.state.activeTab + 1)
        this.$router.push({ path: this.$route.path, query: { activeTab: this.$store.state.activeTab + 1 } })
      }
    },
    previous () {
      this.arrowBounce(this.$refs.leftArrow)
      if (this.$store.state.activeTab > 0) {
        this.$store.commit('setActiveTab', this.$store.state.activeTab + -1)
        this.$router.push({ path: this.$route.path, query: { activeTab: this.$store.state.activeTab - 1 } })
      } else {
      }
    },
    arrowBounce (arrow) {
      let circle1 = arrow.getElementsByClassName('circle1')[0]
      let circle2 = arrow.getElementsByClassName('circle2')[0]
      const tl = gsap.timeline()
      tl.fromTo(circle1,
        {
          scale: 1,
          transformOrigin: 'center center'
        },
        {
          scale: 1.15,
          duration: 0.1,
          ease: Power1.easeOut
        }
      ).fromTo(circle2,
        {
          scale: 1,
          transformOrigin: 'center center'
        },
        {
          scale: 1.15,
          duration: 0.1,
          delay: -0.05,
          ease: Power1.easeOut
        }
      ).to(circle1,
        {
          scale: 1,
          duration: 0.3,
          ease: Power1.easeOut
        }
      ).to(circle2,
        {
          scale: 1,
          duration: 0.3,
          delay: -0.25,
          ease: Power1.easeOut
        }
      )
    }
  },
  mounted () {
    this.animArrows()
  }
}
</script>
